import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withFirebase, isEmpty, isLoaded } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import PropTypes from 'prop-types';
import {
  openCompanySignupModal,
  openInfluencerSignupModal
} from '../../store/actions/signupModalActions';
import { openSignupModal } from '../../store/actions/signupModalActions';
import MetaTags from 'react-meta-tags';
import 'bootstrap/dist/css/bootstrap.css';
import './Home.css';
import Fade from 'react-reveal/Fade';


const mapDispatchToProps = dispatch => {
  return {
    openCompanySignupModal: () => dispatch(openCompanySignupModal()),
    openInfluencerSignupModal: () => dispatch(openInfluencerSignupModal()),
    openSignupModal: () => dispatch(openSignupModal())
  };
};

const enhance = compose(
    // Map redux state to props
    connect(
        ({ firebase: { auth, profile } }) => ({
          auth,
          profile
        }),
        mapDispatchToProps
    ),
    // Add props.router (used in handlers)
    withRouter,

    // Add props.firebase (used in handlers)
    withFirebase,

    // Add custom props
    withProps(({ auth, profile }) => ({
      authExists: isLoaded(auth) && !isEmpty(auth),
      auth
    }))
);

class LandingB extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false
    };
  }


  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleOpenCompanySignupModal = () => {
    this.props.openCompanySignupModal();
  };

  handleOpenInfluencerSignupModal = () => {
    this.props.openInfluencerSignupModal();
  };

  handleOpenLoginModal = e => {
    e.preventDefault();
    this.props.openSignupModal();
  };

  componentDidMount() {
  }

  render() {
    const additonalButtonStyle = {
      textAlign: 'center',
      margin: '0 auto'
    }
    const highlightTextStyle ={
      color: "#1fc26e"
    }
    const brandSectionStyle = {
      color: 'transparent',
      backgroundSize: "cover",
      // minHeight: '100%',
    }
    return (
      <React.Fragment>
        <div className="for-companies-container">
          <MetaTags>
            <title>Hype Up Your Reach for Free with HypePilot</title>
            <meta
                name="description"
                content="Connect with and source the hottest influencers on leading platforms like YouTube. Our platform allows direct messaging with influencers and provides the info that counts via analytics which provide details like follower counts and more."
            />
            <meta
                name="keywords"
                content="Influencer Marketing, Influencer Platform, Influencer Marketplace,YouTube Influencers, Instagram Influencers, Twitch Influencers,YouTube,Instagram,Twitch,Influencer,Influencers,Marketplace,Platform"
            />
          </MetaTags>
          <div className="nav-bar-holder">
            <nav className="navbar navbar-expand-sm navbar-light" />
          </div>
            <Fade top>
          <div className="text-header-container">
            <div className="container">
              <div className="header-holder">
                <h1 className="page-text-heading-brand" style={{width: '80%'}}>Gamer-Centric Digital Marketing Just for You</h1>
              </div>
              <p className="padded-top-paragraph">
                Let’s face it. You need better digital marketing
                that reaches the right people you need in your corner.
                HypePilot lets you <b style={highlightTextStyle}>connect with gaming influencers</b> and{' '}
                <b style={highlightTextStyle}>professional esports influencers</b> without charging you a dime.
                Why? Because we truly believe that there’s a need for an <b style={highlightTextStyle}>open
                gaming marketplace</b> that’s built on the love of the game and
                everything that comes with it. With HypePilot, you can:
              </p>
              <ul>
                <li> <b style={highlightTextStyle}>Connect with gaming influencers</b></li>
                <li>Buy the perfect gaming media or content</li>
                <li>Laser-target your audience and potential customers</li>
                <li>Create, run, and manage <b style={highlightTextStyle}>gaming product campaigns</b></li>
                <li>Track your analytics to see what works and what doesn’t</li>
              </ul>
            </div>
          </div>
        </Fade>

        <Fade bottom>
          <div className="brands-section" style={{
            ...brandSectionStyle,
            minHeight:"50vh",
            backgroundPosition: 'center',
            backgroundImage: "url('images/landing/pexels-rodnae-productions-7915224.jpg')"
          }}/>
          </Fade>
          <Fade top>
          <div className="text-header-container container">
          <div className="header-holder">
            <h1 className="page-text-heading-brand" style={{width: '80%'}}>Growing Your Gaming Audience, One Campaign at A Time</h1>
          </div>
          <p className="padded-top-paragraph">
            Are you a brand or company that needs <b style={highlightTextStyle}>gamer-centric
            digital marketing</b> or <b style={highlightTextStyle}>gaming product campaigns</b> that
            actually get seen by the right people? You’re in the right place.
            HypePilot not only connects you to gaming influencers,
            but also gives you the free reign of an open gaming
            marketplace that won’t make you give up your
            hard-earned content or product ownership.
          </p>

          </div>
          </Fade>
          <Fade bottom>
          <div className="brands-section" style={{
            ...brandSectionStyle,
            minHeight:"50vh",
            backgroundPosition: 'center',
            backgroundImage: "url('images/landing/pexels-cottonbro-4009594.jpg')"
          }}/>
          </Fade>
          <Fade top>
          <div className="text-header-container container">
            <div className="header-holder">
              <h1 className="page-text-heading-brand" style={{width: '80%'}}>Connecting Gamers to Companies Who Care</h1>
            </div>
            <p className="padded-top-paragraph">
              Are you a <b style={highlightTextStyle}>professional esports influencer</b>,
              or have you recently gotten into streaming,
              reviewing, or building? HypePilot is here to
              connect you to the companies and brands that will
              help skyrocket your following. You’ll not only
              start building relationships with some cool people –
              and some even cooler brands – but you’ll also get
              access to awesome payments that will help you keeping growing.
              As an influencer, HypePilot will help you <b style={highlightTextStyle}>grow your gaming audience</b> by:
            </p>
            <ul>
              <li>Connecting you to professional gaming brands, clothing, and gear</li>
              <li>Letting you get to know your gaming
                marketing partners before you start working together</li>
              <li>Giving you complete power and ownership over your brand and the content you create</li>
              <li>Securing an additional stream of income that includes awesome gaming products</li>
              <li>Ensuring quick and reliable pay-outs</li>
            </ul>

          </div>
          </Fade>
          <Fade bottom>
          <div className="brands-section" style={{
            ...brandSectionStyle,
            minHeight:"50vh",
            backgroundPosition: 'center',
            backgroundImage: "url('images/landing/pexels-rodnae-productions-7915492.jpg')"
          }}/>
          </Fade>
          <Fade top>
          <div className="text-header-container container">
            <div className="header-holder">
              <h1 className="page-text-heading-brand" style={{width: '80%'}}>Press “Start” To Begin</h1>
            </div>
            <p className="padded-top-paragraph">
              We’re excited.
              Are you? Once you’ve signed up to HypePilot,
              you can start growing your audience faster and
              easier than ever.
              Create your first campaign now and get ready to grow.
            </p>
              <span
                onClick={this.handleOpenLoginModal}
                className="btn py-3 px-5 influencer-signup-nav-link banner-content">Start</span>
              <br/>
          </div>
          </Fade>
          <div className="brands-section" style={{
            ...brandSectionStyle,
            minHeight:"40vh",
            backgroundPosition: 'center',
            color: "white",
            backgroundImage: "url('images/landing/pexels-lucie-liz-3165335.jpg')"
          }}>
          <div className="text-header-container container" >
            <div className="header-holder">
              <h1 className="page-text-heading-brand" style={{width: '80%'}}>Contact Us</h1>
            </div>
            <p className="padded-top-paragraph">
              If you have any questions about our
              {' '}<b style={highlightTextStyle}>gaming marketing platform</b>{' '}
              and what you as an influencer or brand can do with it,
              reach out to our team today. We’re ready and
              waiting to give you more information, insight,
              and interesting tidbits about what
              {' '}<b style={highlightTextStyle}>gamer-centric digital marketing</b>{' '}
              can do for you.
            </p>
              <a onClick={() => {
                window.open("https://calendly.com/hypepilot/15min", "_blank")
              }}
                 className="btn py-3 px-5 influencer-signup-nav-link banner-content"
                 style={additonalButtonStyle}>
                Schedule Demo
              </a>
            <br/>
            <br/>

          </div>
          </div>

          <div className="nav-bar-holder">
            <nav className="navbar navbar-expand-sm navbar-light" />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

LandingB.propTypes = {
  authExists: PropTypes.bool,
  router: PropTypes.object
};

export default enhance(LandingB);



// WEBPACK FOOTER //
// ./src/components/home/LandingB.js